module.exports = __webpack_public_path__ + "static/media/intero_bleu.1ec76fb8.svg";